import styles from './ComponentsTabPanel.module.scss';

import { Panel } from '../../../../../components/panel/Panel';

import { ComponentsWithAutoDisable } from './components/Components';

export const ComponentsTabPanel = () => {
  return (
    <Panel className={styles.maxHeight}>
      <ComponentsWithAutoDisable
        showSelectionColumn={true}
        showBorders={true}
      />
    </Panel>
  );
};
